import { InfoIcon } from '@panwds/icons';
import { classNames, tw, twMerge } from '@panwds/tailwindcss';
import React from 'react';
import { useIntl } from 'react-intl';
import { testIdGen } from '../../utils/index.js';
import { Tooltip } from '../Tooltip/index.js';
const sizes = {
    sm: tw `twds-text-xs`,
    md: tw `twds-text-xs`,
    lg: tw `twds-text-sm`
};
const height = {
    sm: tw `twds-h-6`,
    md: tw `twds-h-8`,
    lg: tw `twds-h-10`
};
const gap = {
    sm: tw `twds-gap-0.5`,
    md: tw `twds-gap-1`,
    lg: tw `twds-gap-1`
};
/*
 * Handles rendering of form controls and their related properties like labels and errors.
 */
export function Label({ asteriskAlign = 'right', control, dataTestId, dataMetrics, description, disabled, error, label, labelAlign = 'top', addLabelClassnames, labelId, labelTextAlignment = 'left', optional = false, requiredText = false, requiredAsterisk = false, showLabel = true, tooltip, size = 'md' }) {
    const intl = useIntl();
    const rootClassName = classNames('twds-font-lato twds-text-xs twds-max-w-max', disabled ? 'twds-text-disabled' : 'twds-text-gray-700');
    const inputLabelWrapper = classNames('twds-flex twds-gap-x-2 twds-gap-y-2', labelAlign === 'left' && 'twds-items-start', labelAlign === 'top' && 'twds-flex-col', disabled ? 'twds-text-gray-400 dark:twds-text-gray-600' : 'twds-text-gray-600 dark:twds-text-secondary-dark');
    const labelTextClasses = twMerge('twds-flex', !showLabel && 'twds-sr-only', sizes[size], gap[size], labelTextAlignment === 'right' && 'twds-justify-end', addLabelClassnames);
    return (React.createElement("span", { "data-metrics": dataMetrics, "data-testid": dataTestId || (label ? `field-${typeof label === 'string' && testIdGen(label)}` : 'field'), className: rootClassName },
        React.createElement("div", { className: inputLabelWrapper },
            React.createElement("div", { className: classNames(labelAlign === 'left' && height[size], labelAlign === 'left' && 'twds-flex twds-items-center') },
                React.createElement("label", { className: labelTextClasses, id: labelId, "data-testid": labelId },
                    React.createElement("div", { className: "twds-font-semibold" }, label),
                    requiredAsterisk && (React.createElement("span", { className: classNames('twds-relative twds-top-1 twds-text-[20px] twds-font-black', asteriskAlign === 'left' && 'twds-order-[-1]', disabled
                            ? 'twds-text-red-600  dark:twds-text-red-500  dark:twds-opacity-40'
                            : 'twds-text-red-500 dark:twds-text-red-600') }, "*")),
                    !requiredText && !requiredAsterisk && optional && (React.createElement("div", { className: "twds-font-normal" }, intl.formatMessage({
                        defaultMessage: '(Optional)',
                        id: '6Pi4kz',
                        description: 'Field is optional'
                    }))),
                    !optional && !requiredAsterisk && requiredText && (React.createElement("div", { className: "twds-font-normal" }, intl.formatMessage({
                        defaultMessage: '(Required)',
                        id: 'BXn4r0',
                        description: 'Field is required'
                    }))),
                    tooltip && (React.createElement(Tooltip, { label: tooltip },
                        React.createElement(InfoIcon, { "aria-label": tooltip, className: classNames(!disabled && 'twds-text-gray-700 dark:twds-text-secondary-dark') }))))),
            React.createElement("div", { className: "twds-flex twds-flex-col twds-gap-y-1" },
                React.createElement("div", null, control),
                !description && error && React.createElement("div", { className: "twds-text-red dark:twds-text-red-400" }, error),
                !error && description && (React.createElement("div", { className: classNames('twds-mt-1', disabled
                        ? 'twds-text-disabled dark:twds-text-dark-bg-disabled'
                        : 'twds-text-secondary dark:twds-text-dark-bg-secondary') }, description))))));
}
//# sourceMappingURL=Label.js.map